import { ReactNode } from "react";
import { useT } from "../i18n";
import HoverCard from "./HoverCard";

// Iconiță ⓘ cu explicația la hover: ce e mărimea, de ce se calculează așa și
// fiecare parametru cu numele lui în clar și cu locul de unde a fost obținut.
//
// Poziționarea, derularea conținutului lung și fixarea la clic nu mai sunt
// aici: sunt în `HoverCard`, folosit identic de mărimi și de verificări. Așa
// arată și se poartă la fel peste tot.

export interface Param {
  simbol: string;
  nume: string;  // ce reprezintă parametrul
  sursa: string; // de unde a fost obținut (pasul sau documentul)
}

export interface CorpProps {
  titlu?: string;
  ce: ReactNode;
  deCe?: ReactNode;
  parametri?: Param[];
  /** VALOARE aplicată vs LIMITĂ — se vede și pe iconiță, nu doar la hover */
  natura?: ReactNode;
}

/** CONȚINUTUL cartonașului, fără declanșator.
 *
 *  Există separat fiindcă declanșatorul nu e întotdeauna iconița ⓘ: de pe
 *  se poate da hover și direct pe SIMBOLUL din text sau din
 *  formulă (`<S>`, `<TextSimboluri>` din `Simbol.tsx`). Corpul rămâne unul
 *  singur, deci explicația arată identic oriunde se deschide. */
export function CorpInfo({ titlu, ce, deCe, parametri, natura }: CorpProps) {
  const t = useT();
  return (
    <>
          {titlu && <span className="fx-tip-title">{titlu}</span>}
          {natura}
          <span className="fx-tip-block">
            <span className="fx-tip-label">{t("struct.info.pe_scurt")}</span>
            <span>{ce}</span>
          </span>
          {deCe && (
            <span className="fx-tip-block">
              <span className="fx-tip-label">{t("struct.info.de_ce")}</span>
              <span>{deCe}</span>
            </span>
          )}
          {parametri && parametri.length > 0 && (
            <span className="fx-tip-block">
              <span className="fx-tip-label">
                {t("struct.info.parametrii")}
              </span>
              <span className="fx-params">
                {parametri.map((p) => (
                  <span key={p.simbol} className="fx-param">
                    <code>{p.simbol}</code>
                    <span>
                      <strong>{p.nume}</strong>
                      <span className="cv-de-unde">{t("struct.info.de_unde_vine", { sursa: p.sursa })}</span>
                    </span>
                  </span>
                ))}
              </span>
            </span>
          )}
    </>
  );
}

export default function Info(props: CorpProps) {
  const t = useT();
  return (
    <HoverCard
      clasaAncora="fx-info"
      eticheta={props.titlu
        ? t("struct.info.explicatie_pentru", { ce: String(props.titlu) })
        : t("struct.info.explicatie")}
      continut={<CorpInfo {...props} />}
    >
      <span className="fx-info-icon" aria-hidden="true">i</span>
    </HoverCard>
  );
}
